import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import Button from '../design-system/components/atoms/button';
import { Images } from '../app-constants';
import ImageIcon from '../components/images/image-icon';
import { accessibleOnClick } from '../utils/accessible-on-click';
import { openChatSupport } from '../utils/open-chat-support';
import S3StaticImage from '../utils/s3-static-images';

type IProps = WithTranslation;

class ErrorFallback extends React.Component<IProps> {
  componentDidCatch(error: Error) {
    console.error('Caught in ErrorFallback:', error.message);

    // Auto reload if NotFoundError occur
    if (
      error?.message?.includes('NotFoundError') &&
      (error?.message?.includes('insertBefore') ||
        error?.message?.includes('removeChild'))
    ) {
      console.log('Auto Reloading...');
      window.location.reload();
    }
  }

  openBeacon = () => {
    openChatSupport();
  };

  onRefresh = () => {
    window.location.reload();
  };

  render() {
    const { t } = this.props;

    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <span className="semibold-3 gray-txt-17">
          {t('messages.error_boundary_title')}
        </span>
        <div className="mt-5">
          <S3StaticImage imagePath="broken.svg" alt="broken" />
        </div>
        <span className="mt-5 regular-3 font-weight-500 gray-txt-15">
          {t('messages.error_boundary_sub_text_one')}
        </span>
        <div className="mt-2">
          <span className="regular-3 font-weight-500 gray-txt-15">
            {t('messages.error_boundary_sub_text_two')}
          </span>
          <span
            {...accessibleOnClick(this.openBeacon)}
            className="ml-1 regular-3 font-weight-500 blue-txt-11 pointer"
          >
            {t('labels.Contact_Support')}.
          </span>
        </div>
        <Button
          variant={Button.Variant.Primary}
          onClick={this.onRefresh}
          className="mt-4"
        >
          {t('messages.return_to_application')}
        </Button>
      </div>
    );
  }
}

export default withTranslation()(ErrorFallback);
